module.exports = __webpack_public_path__ + "static/media/background-forest.162bf4c1.jpg";